import React from "react"
import PropTypes from "prop-types"
import { fetchEntity, fetchEntities } from "datastory-shared/utils/hasura"
import { SiteMeta } from "datastory-shared/sections"

import withService from "utils/hoc/withService"
import { getServiceProps, getPageProps } from "utils/ssg"
import { SinglePage } from "components/pages/services/glossary/SinglePage"
import { ListingPage } from "components/pages/services/glossary/ListingPage"

const Page = props => {
  const { category, categories, glossaryItem, service } = props

  const item =
    glossaryItem || (category && categories.find(i => i.id === category))

  const title =
    item && `${item.og_name?.[0]?.i18n} | ${service?.og_name[0]?.i18n}`

  return (
    <>
      <SiteMeta title={title} />
      {glossaryItem ? <SinglePage {...props} /> : <ListingPage {...props} />}
    </>
  )
}

Page.propTypes = {
  service: PropTypes.object,
  glossaryItem: PropTypes.object,
  category: PropTypes.string,
  categories: PropTypes.array,
}

export const getStaticPaths = async ({ locales }) => {
  const categories = await Promise.all(
    locales.map(locale =>
      fetchEntities({
        classId: "og:DatastoryGlossaryItem",
        language: locale,
      })
    )
  )

  return {
    paths: locales
      .map(locale => [
        { params: { param: [] }, locale },
        ...categories.flat().map(c => ({
          params: { param: [c.id] },
          locale,
        })),
      ])
      .flat(),
    fallback: "blocking",
  }
}

export const getStaticProps = async ({
  locale: language,
  params: { param },
}) => {
  const pageProps = {}

  if (!param || param.length <= 1) {
    pageProps.category = param ? param[0] : null
    pageProps.glossaryItems = await fetchEntities({
      classId: "og:DatastoryGlossaryItem",
      language,
    })
    pageProps.categories = await fetchEntities({
      classId: "og:DatastoryGlossaryCategory",
      language,
    })

    if (
      pageProps.category &&
      !pageProps.categories.find(c => c.local_id === pageProps.category)
    )
      return { notFound: true }
  } else {
    pageProps.glossaryItem = await fetchEntity({
      id: `og:${param[1]}`,
      language,
    })
    if (!pageProps.glossaryItem) return { notFound: true }
  }

  const serviceProps = await getServiceProps("og:page--6a7c04a9", language)

  return await getPageProps({
    language,
    namespaces: ["og_page--6a7c04a9"],
    pageProps: {
      ...pageProps,
      ...serviceProps,
    },
    revalidate: 10,
  })
}

export default withService(Page)
